import React, {useState} from 'react';
import {copyObject, getFormData, prepareFormData, validateForm} from "../../shared/utility";
import Alert from "@material-ui/lab/Alert";
import {makeStyles} from "@material-ui/core/styles";
import {green} from "@material-ui/core/colors";
import {connect} from "react-redux";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {Box, FormHelperText} from "@material-ui/core";
import {getVehicleImages, VehicleImageTypes, VehicleImageTypeLabels, pushVehicleImageByLink, getVehicleImageByType} from "../../shared/vehicle";
import * as actions from "../../store/actions";
import ImageGridUploader from '../UI/ImageGridUploader';

const useStyles = makeStyles((theme) => ({
    instructions: {
        fontFamily: "Mulish",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "20px",
        lineHeight: "25px",
        color: "#FEFFFF",
        paddingBottom: "16px"
    },
    label: {
        fontFamily: "Mulish",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "16px",
        lineHeight: "20px",
        display: "flex",
        alignItems: "flex-end",
        color: "#FEFFFF",
        paddingBottom: "4px"
    },
    formElement: {
        paddingBottom: "8px",
        '& .MuiFormHelperText-contained': {
            marginLeft: "0px",
        },
    },
    buttonProgress: {
        color: green[500],
        marginLeft: theme.spacing(1),
    },
    wrapper: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        position: 'relative',
    },
    button: {
        marginLeft: theme.spacing(1),
    },
    input: {
        backgroundColor: "transparent",
        fontFamily: "Mulish",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "16px",
        lineHeight: "20px",
        display: "flex",
        alignItems: "center",
        color: "#FEFFFF"
    }
}));

const createPhotoForm = (vehicle) => {
    const imgControl = {
        label: '',
        value: null,
        controlType: 'image',
        type: null,
        validation: { image: { maxSize: 2 } }
    };

    const formData = {
        controls: {
        },
        imageLoading: {
        },
    
        id: (new Date()).getTime(),
        loading: false,
        valid: false,
        touched: false,
        generalError: null
    
    };

    for (let idx in VehicleImageTypes) {
        const type = VehicleImageTypes[idx];
        const image = vehicle ? getVehicleImageByType(vehicle, type) : {};
        formData.controls['image' + type] = Object.assign({}, imgControl, {
            type,
            label: VehicleImageTypeLabels[type],
            value: image ? image.original : null
        });
    }

    return formData;
}

const getPhotoFormData = (formState, vehicle) => {
    const data = getFormData(formState);
    const intVehicle = copyObject(vehicle);
    for (let idx in data) {
        const uploadedImage = formState.controls[idx];
        if (!uploadedImage || !uploadedImage.value) {
            continue;
        }
        // for existing vehicle
        pushVehicleImageByLink(intVehicle, uploadedImage.value, uploadedImage.type);
    }

    return { images: intVehicle ? intVehicle.images : [] }; // intVehicle ? intVehicle.images : [];
}

const EditPhotos = (props) => {


    let formData = createPhotoForm(props.vehicle);

    const classes = useStyles();
    const [formState, setFormState] = useState(formData);

    //const history = useHistory();

    React.useEffect(() => {
        const state = {}
        formData = prepareFormData(formState, state);
        setFormState(formData);
    }, [props.vehicle]); // null

    const submitHandler = async (event) => {
        event.preventDefault();
        if (validateForm(formState, setFormState)) {
            const data = getPhotoFormData(formState, props.vehicle);
        
            props.onNext(data, nextStep => {
                //props.handleNext()
            })
        }
    }

    const images = getVehicleImages(props.vehicle);
    const formImageIds = formState && formState.controls ? Object.keys(formState.controls) : [];


    const onLoadHandler = (e) => {
        e.setIsUpload(true);
        formState.imageLoading[e.key] = true;
        formState.generalError = null;
        setFormState(formState);
        const uploaderHandler = props.vehicle.id > 0 ? props.uploadVehiclePhoto : props.uploadNewVehiclePhoto;
        uploaderHandler({
            id: props.vehicle.id,
            key: e.key,
            filename: formState.id + '_' + e.key + '_' + (new Date()).getUTCMilliseconds(),
            base64: e.data
        }, (err, data) => {
            e.setIsUpload(false);
            const newFormState = copyObject(e.formState);
            if (newFormState.imageLoading[e.key]) {
                delete newFormState.imageLoading[e.key];
            }
            if (err) {
                // todo: show error
                console.log('error', err);
                setFormState(newFormState);
                return ;
            }
            // todo: update qualify vehicle
            newFormState.controls[e.key].value = data.url;
            setFormState(newFormState);
        });
    }

    const onErrorHandler = (e) => {
        const control = e.formState.controls[e.key];
        if (!control.valid && control.helperText) {
            const newFormState = copyObject(e.formState);
            newFormState.generalError = control.helperText;
            setFormState(newFormState);
        }
    }

    return (
        <React.Fragment>

            <Box className={classes.instructions}>Good photos can increase the offers your vehicle receives. </Box>
            {props.app.error &&
            <div className={classes.wrapper}>
                <Alert severity="error">{props.app.error ?? ''}</Alert>
            </div>
            }
            <ImageGridUploader images={images} formImageIds={formImageIds} formState={formState} setFormState={setFormState} 
                onLoad={onLoadHandler} onError={onErrorHandler} />
            {formState.touched && !formState.valid && <Box display="flex" justifyContent="center">
                <FormHelperText error={true} >{formState.generalError}</FormHelperText>
            </Box>}
            <Box display="flex" justifyContent="flex-end" style={{marginTop: '16px', marginBottom: '30px'}}>
                <div className={classes.wrapper}>
                    <Button className={classes.button} type={"button"} variant={"outlined"} onClick={() => {
                        props.onBack()
                    }}
                    > {props.backButton}</Button>

                    <Button
                        className={classes.button}
                        type={"button"}
                        variant={"contained"}
                        color={"primary"}
                        onClick={submitHandler}
                        disabled={Object.values(formState.imageLoading).length > 0 
                            ||  formState.touched && !formState.valid}
                    >  {props.nextButton}  {props.app.loading &&
                    <CircularProgress size={24} className={classes.buttonProgress}/>}</Button>

                </div>
            </Box>
        </React.Fragment>
    );

}

const mapStateToProps = state => {
    return {
        app: state.app.qualifyVehicle,
        vehicle: state.qualifyVehicle.vehicle
    };
};

const mapDispatchToProps = dispatch => {
    return {
        uploadVehiclePhoto: (data, cb) => dispatch(actions.uploadVehiclePhoto(data, cb)),
        uploadNewVehiclePhoto: (data, cb) => dispatch(actions.uploadNewVehiclePhoto(data, cb)),
        onBack: () => dispatch(actions.backQualifyVehicle()),
        onNext: (data, nextStep) => dispatch(actions.saveQuestions(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditPhotos);
